import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '../model/Store';
import { RequestResponse } from '../model/dto/RequestResponse';

@Injectable()
export class StoreFacade {

  private _urlBase: string;
  private _httpClient: HttpClient;

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this._urlBase = baseUrl;
    this._httpClient = http;
  }

  GetParticipateQuantum(): Observable<RequestResponse<Store[]>> {
    return this._httpClient.get<RequestResponse<Store[]>>(this._urlBase + 'api/Store/Participate');
  }

  GetStoreChecklist(parameters: any): Observable<any> {
    const body = JSON.stringify(parameters);
    return this._httpClient.post(this._urlBase + 'api/Store/StoreChecklist', body, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json'})
    });
  }

  GetAll(): Observable<any> {
    return this._httpClient.get<any>(this._urlBase + 'api/Store/All');
  }

  GetByStoreId(storeId: number): Observable<any> {
    return this._httpClient.get<any>(this._urlBase + 'api/Store/byStore?storeId=' + storeId);
  }

  UpdateStore(item: Store): Observable<RequestResponse<boolean>> {
    return this._httpClient.post<RequestResponse<boolean>>(this._urlBase + 'api/Store/Update', item);
  }

  UpdateMasterData(item: Store): Observable<RequestResponse<boolean>> {
    return this._httpClient.put<RequestResponse<boolean>>(this._urlBase + 'api/Store/UpdateMasterData', item);
  }

  CreateMasterData(item: Store): Observable<RequestResponse<boolean>> {
    return this._httpClient.post<RequestResponse<boolean>>(this._urlBase + 'api/Store/CreateMasterData', item);
  }

  GetByStoreEmail(email: string): Observable<RequestResponse<Store[]>> {
    return this._httpClient.get<RequestResponse<Store[]>>(this._urlBase + 'api/Store/' + email);
  }

  GetCollectionByStoreEmail(email: string): Observable<RequestResponse<Store[]>> {
    return this._httpClient.get<RequestResponse<Store[]>>(this._urlBase + 'api/Store/GetAssignedByStoreEmail?email=' + email);
  }

  GetByOrganizationId(organizationId: string): Observable<RequestResponse<Store[]>> {
    return this._httpClient.get<RequestResponse<Store[]>>(`${this._urlBase}api/Store/ByOrganization${organizationId}`);
    }

    GetAssignedByStoreEmail(): Observable<any> {
        return this._httpClient.get<RequestResponse<Store[]>>(this._urlBase + 'api/Store/GetAssignedByStoreEmail');
    }

}
